/// <amd-module name="Build/Run/Components/RunSummaryChangesLinkComponent" />
import * as React from "react";

import * as Resources from "Build/Run/Resources";

import { ITfsPageService } from "Tfs/Platform/Page";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { routeUrl } from "VSS/Platform/Location";
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { localeFormat } from "VSS/Core/Util/String";
import { Button } from "VSSUI/Button";
import { Observer } from "VSSUI/Observer";

export interface IRunSummaryChangesLinkProps {
    traceabilityChangesCount: IReadonlyObservableValue<number>;
    sourceType: string;
    currentRunId: number;
    linkDescribedBy?: string;
}

const c_ChangesHubDefaultRoute = "ms.vss-traceability-web.traceability-run-changes-hub-default-route";
const c_RouteParameters_Project = "project";
const c_RouteParameters_CurrentRunId = "currentRunId";
const c_RunViewChangesText = "RunViewChanges";
const c_TelemetrySource = "RunSummary";

export class RunSummaryChangesLink extends VssComponent<IRunSummaryChangesLinkProps> {

    constructor(props: IRunSummaryChangesLinkProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render() {
        //  Create route value and URL.
        const routeValues: { [key: string]: string } = {};
        this._initializeRouteValues(this.context.pageContext, routeValues);

        return <Observer traceabilityChangesCount={this.props.traceabilityChangesCount}>
            {
                (observerProps: { traceabilityChangesCount: number }) => {
                    const count = observerProps.traceabilityChangesCount;
                    const className = "text-ellipsis flex-row flex-baseline";
                    let url = routeUrl(this.context.pageContext, c_ChangesHubDefaultRoute, routeValues);

                    if (!!count && count > 0) {

                        const text = (count == 1) ? Resources.ViewChange : localeFormat(Resources.ViewChanges, count.toString());
                        return (
                            <Button ariaDescribedBy={this.props.linkDescribedBy} className={className} href={url} onClick={this._onClick}>
                                {text}
                            </Button>
                        );
                    }
                    else if (!!count) {
                        const text = (count == 1) ? Resources.ViewChange : localeFormat(Resources.ViewChanges, count.toString());
                        return (
                            <Button ariaDescribedBy={this.props.linkDescribedBy} className={className}>
                                {text}
                            </Button>
                        );
                    }
                    else {
                        return null;
                    }
                }
            }
        </Observer>
    }

    private _initializeRouteValues(pageContext: IVssPageContext, routeValues: { [key: string]: string }) {
        let projectName: string = "";

        const tfsPageService = pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();

        if (tfsPageData) {
            if (!projectName && tfsPageData.project) {
                projectName = tfsPageData.project.name;
            }
        }

        if (projectName) {
            routeValues[c_RouteParameters_Project] = projectName;
        }

        if (this.props.currentRunId) {
            routeValues[c_RouteParameters_CurrentRunId] = this.props.currentRunId.toString();
        }
    }

    private _onClick() { const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent("WebPlatform", "Link", {
            ...{clickedOn: c_RunViewChangesText},
            source: c_TelemetrySource
        });
    }
}